"use strict";exports.SPACING={empty:"0px",xxxSmall:"2px",xxSmall:"4px",xSmall:"8px",small:"12px",medium:"16px",large:"20px",xLarge:"24px",xxLarge:"32px"};
//# sourceMappingURL=spacing.js.map
